exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-wrapper {\n  max-height: 90vh; }\n\n.img {\n  display: block;\n  width: 70vw;\n  height: 70vh; }\n  .img img {\n    display: block;\n    position: relative;\n    top: 50%;\n    transform: translateY(-50%);\n    margin: 0 auto;\n    max-width: 100%;\n    max-height: 100%; }\n\n.modal-body {\n  width: 100%;\n  height: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/image-carousel/image-carousel.component.scss
// module id = 975
// module chunks = 1